import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89cd1ef2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-[99999] bg-black bg-opacity-40"
}
const _hoisted_2 = {
  key: 0,
  class: "bg-white text-black p-4 rounded shadow-lg min-w-[300px]"
}
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "flex justify-end gap-2" }

import { useToast } from "@/services/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'Toast',
  setup(__props) {

const { visible, message, type, confirmYes, confirmNo } = useToast();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "toast-fade" }, {
    default: _withCtx(() => [
      (_unref(visible))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(type) === 'confirm')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(message)), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      class: "px-3 py-1 bg-gray-300 rounded",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(confirmNo) && _unref(confirmNo)(...args)))
                    }, " Cancelar "),
                    _createElementVNode("button", {
                      class: "px-3 py-1 bg-red-500 text-white rounded",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(confirmYes) && _unref(confirmYes)(...args)))
                    }, " Eliminar ")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["px-6 py-3 rounded shadow-lg text-white", _unref(type) === 'success' ? 'bg-green-500' : 'bg-red-500'])
                }, _toDisplayString(_unref(message)), 3))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})